'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

var _getProductInfo = require('../services/shopify/getProductInfo');

var _getProductInfo2 = _interopRequireDefault(_getProductInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Add To Cart - Vue Component
----------------------------*/

_vue2.default.component('add-to-cart-subscription-gift', {
  data: function data() {
    return {
      productHandle: window.location.pathname.split('/').pop(),
      selectedOptions: {},
      addToCartStatus: 'idle',
      variants: [],
      options: [],
      feedbackMessage: '',
      quantity: 1,
      productHasVariants: true,
      recipientName: '',
      recipientEmail: '',
      recipientMessage: ''
    };
  },

  mounted: function mounted() {
    this.setInitialProductData();
  },
  methods: {
    /*----------------------------
    Set Initial Product Data
    ----------------------------*/

    setInitialProductData: function setInitialProductData() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var productInfo;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _getProductInfo2.default)(_this.productHandle);

              case 2:
                productInfo = _context.sent;


                // All Options
                _this.options = productInfo.options;

                // Set Initial Options
                _this.setInitialOptions(productInfo);

                // All Variants
                _this.variants = productInfo.variants;

                // Check if the product has any explicity set variants. If not then shopify added a default variant.
                if (productInfo.variants.length === 1 && productInfo.variants[0].title === 'Default Title') {
                  _this.productHasVariants = false;
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    /*---------------
    Increment Quantity
    ---------------*/
    incrementQuantity: function incrementQuantity() {
      this.quantity++;
    },


    /*---------------
    Decrement Quantity
    ---------------*/
    decrementQuantity: function decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },


    /*---------------
    Set option value
    ---------------*/
    setOptionValue: function setOptionValue(optionName, value) {
      // Set the option
      _vue2.default.set(this.selectedOptions, optionName, value);
      // Update the url to reflect the current variant selection.
      this.updateProductURL();
    },


    /*---------------
    Update Product URL
    ---------------*/
    updateProductURL: function updateProductURL() {
      // Save the updated product url with the variant id appended as a query string.
      var updatedURL = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + this.selectedVariant.id;
      // Replace the url without refreshing the page.
      window.history.replaceState({ path: updatedURL }, '', updatedURL);
    },


    /*---------------
    Set initial options
    ---------------*/
    setInitialOptions: function setInitialOptions(productInfo) {
      var _this2 = this;

      // Get the query string parameters from the url.
      var urlParams = new URLSearchParams(window.location.search);
      var initialVariantId = Number(urlParams.get('variant'));
      // If a variant ID is set then get the initial options from that variant.
      if (initialVariantId) {
        // Find the variant
        var initialVariant = productInfo.variants.find(function (variant) {
          return variant.id === initialVariantId;
        });
        // Loop through each of the variants options
        initialVariant.options.forEach(function (option, index) {
          // Set the option in state with its corresponding option name.
          _vue2.default.set(_this2.selectedOptions, productInfo.options[index].name, option);
        });
      }
      // Else populate the initial options based on the first value for each option.
      else {
          productInfo.options.forEach(function (option) {
            _vue2.default.set(_this2.selectedOptions, option.name, option.values[0]);
          });
        }
    },


    /*---------------
    Add Product To Cart
    ---------------*/
    addProductToCart: function addProductToCart() {
      var _this3 = this;

      // Selected variant id
      var variantId = this.selectedVariant.id;

      // Indicate that the product is being added.
      this.addToCartStatus = 'loading';

      // Save the product data for a one time variant purchase.

      var productData = {
        id: variantId,
        quantity: this.quantity,
        properties: {
          recipient_name: this.recipientName,
          recipient_email: this.recipientEmail,
          recipient_message: this.recipientMessage
        }
      };

      // Send the product to the cart.

      this.$store.dispatch('cart/addCartItem', productData).then(function () {
        // On success indicate it and show the mini cart.
        _this3.$store.dispatch('cart/toggleMiniCart');
        _this3.addToCartStatus = 'done';
        window.setTimeout(function () {
          _this3.addToCartStatus = 'idle';
        }, 2000);
      }).catch(function (error) {
        // On error show the error message on the page

        _this3.feedbackMessage = error;
        _this3.addToCartStatus = 'idle';
        window.setTimeout(function () {
          _this3.feedbackMessage = '';
        }, 3000);
      });
    }
  },
  computed: {
    /*---------------
    Selected Variant
    ---------------*/

    selectedVariant: function selectedVariant() {
      var _this4 = this;

      // Get the variant that matches our currently selected options.
      return this.variants.find(function (variant) {
        return (0, _isEqual2.default)(variant.options, Object.values(_this4.selectedOptions));
      });
    },


    /*---------------
    Selected Variant Price
    ---------------*/

    // Get the price of the selected variant (option/value combo).
    selectedVariantPrice: function selectedVariantPrice() {
      var _this5 = this;

      var selectedVariant = this.variants.find(function (variant) {
        return (0, _isEqual2.default)(variant.options, Object.values(_this5.selectedOptions));
      });
      if (selectedVariant) {
        return currency.formatMoney(selectedVariant.price);
      }
    }
  }
});